import { apiService } from './api';
import { User } from '../types';

export interface Release { version: string; date: string | null; title: string; sections: { heading: string; items: string[] }[] }
export interface Feedback { id: number; status: string; github_issue_number?: number; github_issue_url?: string; description?: string; role?: string; source?: string; created_at?: string; has_screenshot?: boolean }
let releasesRequest: Promise<Release[]> | undefined;

const latestReleaseRequests = new Map<string, Promise<{ version: string }>>();
export const helpService = {
  latestRelease: (userId: string) => {
    if (!latestReleaseRequests.has(userId)) {
      const request = apiService.get<{ version: string }>('/changelog/latest').catch(error => {
        latestReleaseRequests.delete(userId);
        throw error;
      });
      latestReleaseRequests.set(userId, request);
    }
    return latestReleaseRequests.get(userId)!;
  },
  releases: () => {
    if (!releasesRequest) {
      releasesRequest = apiService.get<Release[]>('/changelog').catch(error => {
        releasesRequest = undefined;
        throw error;
      });
    }
    return releasesRequest;
  },
  saveState: (state: Record<string, string>) => apiService.patch<User>('/auth/me/ui-state', state),
  context: () => apiService.get<{ app_version: string }>('/feedback-context'),
  reportById: (id: string) => apiService.get<Feedback>(`/feedback/${id}`),
  reports: (offset = 0) => apiService.get<Feedback[]>('/feedback', { offset }),
  async report(description: string, page: string, screenshot?: File): Promise<Feedback> {
    const body = new FormData();
    body.append('description', description);
    body.append('page_url', page);
    if (screenshot) body.append('screenshot', screenshot);
    const response = await fetch(`${apiService.getBaseUrl()}/feedback`, { method: 'POST', headers: await apiService.authHeaders(), body });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not send your report. Please try again.');
    }
    return response.json();
  },
  async screenshot(id: number): Promise<Blob> {
    const response = await fetch(`${apiService.getBaseUrl()}/feedback/${id}/screenshot`, { headers: await apiService.authHeaders() });
    if (!response.ok) throw new Error('Could not load screenshot.');
    return response.blob();
  },
};
